// @flow

import React, { Component } from 'react';

import { Questions } from '../../assets/model';

import type answer from './_QuestionHandler';

type Props = {
  question: number,
  onClick?: (number: number, answer: answer) => void,
  onNext?: () => void
};

type State = {
  value: string
};

class TextField extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: ''
    };
  }

  _handleChange = (event, answer) => {
    this.setState(
      {
        value: event.target.value
      },
      () => {
        answer.value = this.state.value;
        this.props.onClick(this.props.question, answer);
      }
    );
  };

  render() {
    const { question } = this.props;
    const { text } = Questions[question].answers[0];
    const answer = Questions[question].answers[0];
    return (
      <React.Fragment>
        <div className="textField">
          <textarea
            onChange={e => {
              this._handleChange(e, answer);
            }}
            value={this.state.value}
            placeholder={text}
            className="specialField"
          />
        </div>{' '}
        <div className="bottomBar bottomBar--buttonRight">
          <div
            onClick={
              // this.props.onNext(Questions[question].answers[0].nextQuestion);
              this.props.onNext
            }
            className="button"
          >
            Weiter{' '}
          </div>{' '}
        </div>{' '}
      </React.Fragment>
    );
  }
}

export default TextField;



// WEBPACK FOOTER //
// ./src/components/questions/TextField.js